// extracted by mini-css-extract-plugin
export default {"backToLogin":"backToLogin_f32ZdGj8"};